import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, first, map, tap } from 'rxjs';
import { CategoryResolvedConfigurationStoreActions } from '../category-resolved-configuration';
import { selectCurrentCategoryFromRouter } from '../router/router.selector';

/**
 * Resolver to fetch category resolved configurations (with inheritance applied) before navigating to a route.
 * It dispatches an action to request the resolved category configuration based on the current category from the router.
 * @returns An observable that resolves to true when the action is dispatched.
 */
export const categoryResolvedConfigurationsResolver: ResolveFn<boolean> = () => {
  const store = inject(Store);

  return store.select(selectCurrentCategoryFromRouter).pipe(
    filter((category) => !!category),
    first(),
    tap((category) => {
      store.dispatch(
        CategoryResolvedConfigurationStoreActions.CategoryResolvedConfigurationResolverActions.categoryResolvedConfigurationRequested(
          {
            categoryId: category.categoryId,
          }
        )
      );
    }),
    map(() => true)
  );
};
